export var API_BASE = 'https://api.lemonlive1.lemonconcentrate.com/api/';
export var BASE = 'https://api.lemonlive1.lemonconcentrate.com/';

// export var API_BASE = 'http://localhost/lemon-gestor/back/public/api/';
// export var BASE = 'http://localhost/lemon-gestor/back/public/';

export var BASE_ROUTER = '/';

export var BASE_ASSETS = '';

export var AUTH_HEADER = 'Authorization';



// WEBPACK FOOTER //
// ./src/config.js